import React from "react";
import { useNavigate } from "react-router-dom";

function TargetShop(props) {
  let navigate = useNavigate();

  return (
    <>
      <div
        className="h-12 leading-6 bg-red-700 text-zinc-800"
        style={{ outline: 0, transition: "height 0.4s ease-in-out 0s" }}
      >
        <div
          className="flex justify-between items-center px-5 my-0 mx-auto h-12 text-zinc-800"
          style={{ outline: 0, maxWidth: 1400 }}
        >
          <div className="flex justify-start" style={{ outline: 0 }}>
            <div className="text-zinc-300" style={{ outline: 0 }}>
              <button
                type="button"
                aria-expanded="false"
                data-test="@web/StoreMessage/Button"
                id="web-store-id-msg-btn"
                className="flex relative flex-col justify-center p-0 m-0 h-10 font-sans text-base not-italic tracking-normal leading-none text-left normal-case align-middle bg-transparent rounded border border-transparent border-solid cursor-pointer select-none box-border truncate indent-0 focus:outline-offset-2 focus:outline-zinc-300"
                style={{
                  boxShadow: "none",
                  alignItems: "start",
                  fontWeight: "normal",
                  textShadow: "none",
                  textDecoration: "none",
                }}
              >
                <div
                  className="text-sm leading-3 text-white whitespace-nowrap"
                  data-test="@web/StoreMessage/NoStore"
                  style={{ outline: 0 }}
                >
                  Please select a store
                </div>
              </button>
              <div
                aria-live="polite"
                className="inline-block overflow-hidden absolute -m-px w-px h-px"
                style={{ outline: 0, clip: "rect(0px, 0px, 0px, 0px)" }}
              />
            </div>
          </div>
          <div className="flex justify-end" style={{ outline: 0 }}>
            <div className="hidden items-center sm:flex" style={{ outline: 0 }}>
              <div className="hidden md:flex" style={{ outline: 0 }}>
                <div
                  className="overflow-visible relative p-2 ml-8 text-xs text-white align-baseline bg-transparent border-0 cursor-pointer focus:text-zinc-300 focus:outline-dashed focus:outline-1 hover:text-zinc-300"
                  data-ff-lnk-nav-click-text="Registry"
                  data-test="@web/GlobalHeader/UtilityHeader/Registry"
                  id="utilityNav-registries"
                  to="/gift-registry"
                  style={{ textDecoration: "none", boxShadow: "none" }}
                >
                  Registry
                </div>
                <div
                  className="overflow-visible relative p-2 ml-8 text-xs text-white align-baseline bg-transparent border-0 cursor-pointer focus:text-zinc-300 focus:outline-dashed focus:outline-1 hover:text-zinc-300"
                  data-ff-lnk-nav-click-text="Weekly Ad"
                  data-test="@web/GlobalHeader/UtilityHeader/WeeklyAd"
                  id="utilityNav-weeklyAd"
                  style={{ textDecoration: "none", boxShadow: "none" }}
                >
                  Weekly Ad
                </div>
                <div
                  className="overflow-visible relative p-2 ml-8 text-xs text-white align-baseline bg-transparent border-0 cursor-pointer focus:text-zinc-300 focus:outline-dashed focus:outline-1 hover:text-zinc-300"
                  data-ff-lnk-nav-click-text="RedCard"
                  data-test="@web/GlobalHeader/UtilityHeader/Redcard"
                  id="utilityNav-redCardLI"
                  to="/redcard/about"
                  style={{ textDecoration: "none", boxShadow: "none" }}
                >
                  RedCard
                </div>
                <div
                  className="overflow-visible relative p-2 ml-8 text-xs text-white align-baseline bg-transparent border-0 cursor-pointer focus:text-zinc-300 focus:outline-dashed focus:outline-1 hover:text-zinc-300"
                  data-ff-lnk-nav-click-text="Target Circle"
                  data-test="@web/GlobalHeader/UtilityHeader/TargetCircle"
                  id="utilityNav-circle"
                  to="/circle"
                  style={{ textDecoration: "none", boxShadow: "none" }}
                >
                  Target Circle
                </div>
                <div
                  className="overflow-visible relative p-2 ml-8 text-xs text-white align-baseline bg-transparent border-0 cursor-pointer focus:text-zinc-300 focus:outline-dashed focus:outline-1 hover:text-zinc-300"
                  data-ff-lnk-nav-click-text="Find Stores"
                  data-test="@web/GlobalHeader/UtilityHeader/FindStores"
                  id="utilityNav-findStores"
                  to="/store-locator/find-stores"
                  style={{ textDecoration: "none", boxShadow: "none" }}
                >
                  Find Stores
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* SECCION */}
      <div
        className="relative px-5 my-0 mx-auto leading-6 text-zinc-800"
        style={{ outline: 0, maxWidth: 1400 }}
      >
        <nav
          data-test="@web/HeaderPrimaryNav"
          id="headerPrimary"
          className="flex relative items-center p-0 h-16 bg-white md:h-20 md:py-0 md:pr-4 md:pl-3"
          style={{ zIndex: 1049 }}
        >
          <a
            href="/"
            className="hidden overflow-visible relative p-0 align-baseline bg-transparent border-0 cursor-pointer xl:mr-2 md:mr-6 md:inline-flex md:items-center text-stone-500 focus:text-zinc-800 focus:outline-dashed focus:outline-1 hover:text-zinc-800"
            aria-label="Target home"
            style={{ textDecoration: "underline", boxShadow: "none" }}
          >
            <span
              className="inline-block flex-shrink-0 w-12 h-12 font-sans text-base not-italic tracking-normal text-red-700 normal-case align-baseline whitespace-normal indent-0"
              data-icon-name="LogoBullseyeRed"
              fill="#cc0000"
              style={{
                outline: 0,
                fill: "rgb(204, 0, 0)",
                lineHeight: "1.4285",
                fontWeight: "normal",
                textShadow: "none",
              }}
            >
              <div
                className="w-full h-full"
                style={{ outline: 0 }}
                onClick={() => navigate("/")}
              >
                <img
                  width={24}
                  height={24}
                  alt=""
                  viewBox="0 0 24 24"
                  src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Target_Corporation_logo_%28vector%29.svg/2048px-Target_Corporation_logo_%28vector%29.svg.png"
                  focusable="false"
                  role="presentation"
                  className="block w-full h-full"
                  style={{ fill: "white", stroke: "none" }}
                />
              </div>
            </span>
          </a>
          <div className="relative w-10 h-10 xl:hidden" style={{ outline: 0 }}>
            <div
              aria-expanded="false"
              aria-label="Main menu"
              data-test="@web/Header/MainMenuMobileLink"
              className="flex relative flex-none justify-center items-center w-10 h-10 text-base cursor-pointer xl:ml-2 xl:h-10 xl:py-0 xl:pr-6 xl:pl-4 md:border md:border-dashed md:border-transparent md:p-1 focus,md:rounded-lg focus,md:border focus,md:border-dashed focus,md:border-zinc-800 focus,md:bg-white focus:outline-dashed focus:outline-1 focus:outline-offset-2 hover:rounded-lg hover:bg-neutral-100"
              style={{ textDecoration: "none", fontWeight: "bold" }}
            >
              <span
                className="inline-block flex-shrink-0 w-6 h-6 font-sans not-italic tracking-normal normal-case align-baseline whitespace-normal indent-0"
                data-icon-name="NavigationHamburgerFill"
                fill="#333333"
                size={24}
                style={{
                  outline: 0,
                  fill: "rgb(51, 51, 51)",
                  lineHeight: "1.4285",
                  fontWeight: "normal",
                  textShadow: "none",
                }}
              >
                <div
                  className="w-full h-full text-zinc-800"
                  style={{ outline: 0 }}
                ></div>
              </span>
            </div>
          </div>

          <div
            className="inline-flex overflow-visible absolute top-1/2 left-5 flex-none order-1 items-center p-0 align-baseline bg-transparent border-0 cursor-pointer md:hidden text-stone-500 focus:text-zinc-800 focus:outline-dashed focus:outline-1 hover:text-zinc-800"
            aria-label="Target home"
            style={{
              textDecoration: "underline",
              boxShadow: "none",
              transform: "translate(-50%, -50%)",
            }}
          >
            <span
              className="inline-block flex-shrink-0 w-10 h-10 font-sans text-base not-italic tracking-normal text-red-700 normal-case align-baseline whitespace-normal indent-0"
              data-icon-name="LogoBullseyeRed"
              fill="#cc0000"
              style={{
                outline: 0,
                fill: "rgb(204, 0, 0)",
                lineHeight: "1.4285",
                fontWeight: "normal",
                textShadow: "none",
              }}
            >
              <div
                className="w-full h-full  "
                style={{ outline: 0 }}
                onClick={() => navigate("/")}
              >
                <img
                  width={24}
                  height={24}
                  alt=""
                  viewBox="0 0 24 24"
                  src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Target_Corporation_logo_%28vector%29.svg/2048px-Target_Corporation_logo_%28vector%29.svg.png"
                  focusable="false"
                  role="presentation"
                  className="block w-full h-full"
                  style={{ fill: "white", stroke: "none" }}
                />
              </div>
            </span>
          </div>

          <div
            className="hidden md:relative md:mx-6 md:my-0 md:flex md:flex-auto md:items-center md:justify-end"
            style={{ outline: 0 }}
          >
            <form className="flex relative p-0 m-0 w-full h-10 rounded-lg md:h-10 md:pl-0 bg-neutral-100">
              <input
                aria-label="Search: suggestions appear below"
                autoCapitalize="off"
                autoComplete="off"
                autoCorrect="off"
                data-test="@web/Search/SearchInput"
                id="search"
                placeholder="Search"
                type="search"
                className="box-content flex relative py-0 pr-20 pl-3 m-0 w-full text-base bg-transparent rounded-none border-0 cursor-text resize-none md:py-3 md:pr-20 md:pl-3"
                defaultValue=""
                style={{ outline: "none" }}
              />
              <button
                aria-label="go"
                data-test="@web/Search/SearchButton"
                type="submit"
                className="absolute top-0 right-0 p-0 m-0 w-10 h-12 text-center text-transparent normal-case align-middle bg-transparent border-0 opacity-100 cursor-pointer focus:outline-offset-2"
                style={{ boxShadow: "none" }}
              >
                go
              </button>
            </form>
          </div>
          <div
            aria-expanded="false"
            aria-label="Account"
            data-test="@web/AccountLinkMobile"
            className="flex relative justify-center items-center mr-2 ml-auto w-10 h-10 cursor-pointer md:hidden md:border md:border-dashed md:border-transparent md:p-1 focus,md:rounded-lg focus,md:border focus,md:border-dashed focus,md:border-zinc-800 focus,md:bg-white focus:outline-dashed focus:outline-1 focus:outline-offset-2 hover:rounded-lg hover:bg-neutral-100"
            style={{ textDecoration: "none" }}
          >
            <div
              className="flex justify-center items-center w-10 h-10 md:flex md:items-center md:text-zinc-800"
              style={{ outline: 0 }}
            >
              <img
                alt="Account"
                src="https://target.scene7.com/is/content/Target/GUEST_ad24d0ff-62d6-4c7b-8b24-ae701e51b0f6"
                className="block max-w-full h-auto md:ml-0 md:h-6 md:w-6"
              />
            </div>
          </div>
          <div
            aria-expanded="false"
            aria-label="Account, sign in"
            data-test="@web/AccountLink"
            className="hidden relative justify-center items-center mr-2 ml-auto w-10 h-10 cursor-pointer md:mr-4 md:w-auto md:border md:border-dashed md:border-transparent md:py-0 md:pr-6 md:pl-0 focus,md:rounded-lg focus,md:border focus,md:border-dashed focus,md:border-zinc-800 focus,md:bg-white focus:outline-dashed focus:outline-1 focus:outline-offset-2 hover:rounded-lg hover:bg-neutral-100"
            style={{ textDecoration: "none" }}
          >
            <div
              className="flex justify-center items-center w-10 h-10 md:flex md:items-center md:text-zinc-800"
              style={{ outline: 0 }}
            >
              <img
                alt="Account"
                src="https://target.scene7.com/is/content/Target/GUEST_ad24d0ff-62d6-4c7b-8b24-ae701e51b0f6"
                className="block max-w-full h-auto md:ml-0 md:h-6 md:w-6"
              />
              <span
                className="inline-block flex-shrink-0 w-3 h-3 font-sans text-base not-italic tracking-normal normal-case align-baseline whitespace-normal md:absolute md:hidden md:h-3 md:w-3 indent-0"
                data-icon-name="NavigationArrowDownFill"
                fill="#333333"
                size={12}
                style={{
                  outline: 0,
                  fill: "rgb(51, 51, 51)",
                  lineHeight: "1.4285",
                  fontWeight: "normal",
                  textShadow: "none",
                }}
              >
                <div
                  className="w-full h-full text-zinc-800"
                  style={{ outline: 0 }}
                >
                  <svg
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    focusable="false"
                    role="presentation"
                    className="block w-full h-full"
                    style={{ fill: "white", stroke: "none" }}
                  >
                    <defs className="">
                      <path
                        id="nds-Icon2484a"
                        d="M9.06 12.5l7.47-7.47-1.06-1.06-8.53 8.53 8.53 8.53 1.06-1.06z"
                        className=""
                      />
                    </defs>
                    <use
                      transform="scale(1 -1) rotate(90 24.235 0)"
                      xlinkHref="#nds-Icon2484a"
                      className=""
                    />
                  </svg>
                </div>
              </span>
            </div>
            <span
              className="overflow-hidden text-sm leading-5 overflow-ellipsis"
              style={{ outline: 0, maxWidth: 164, display: "-webkit-box" }}
            >
              Sign in
            </span>
          </div>
          <div
            data-test="@web/CartLink"
            className="flex relative flex-grow-0 flex-shrink-0 justify-center items-center w-10 h-10 cursor-pointer md:border md:border-dashed md:border-transparent md:p-1 focus,md:rounded-lg focus,md:border focus,md:border-dashed focus,md:border-zinc-800 focus,md:bg-white focus:outline-dashed focus:outline-1 focus:outline-offset-2 hover:rounded-lg hover:bg-neutral-100"
            style={{ textDecoration: "none", flexBasis: 44 }}
          >
            <div
              data-test="@web/CartIcon"
              className="w-6 h-6 text-zinc-800"
              style={{ outline: 0 }}
            >
              <span
                className="inline-block overflow-hidden absolute -m-px w-px h-px"
                style={{ outline: 0, clip: "rect(0px, 0px, 0px, 0px)" }}
              >
                cart 0 items
              </span>
              <span
                className="inline-block flex-shrink-0 w-6 h-6 font-sans text-base not-italic tracking-normal normal-case align-baseline whitespace-normal indent-0"
                data-icon-name="CommerceCartLine"
                fill="#333"
                size={24}
                style={{
                  outline: 0,
                  fill: "rgb(51, 51, 51)",
                  lineHeight: "1.4285",
                  fontWeight: "normal",
                  textShadow: "none",
                }}
              >
                <div className="w-full h-full" style={{ outline: 0 }}>
                  <svg
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    focusable="false"
                    role="presentation"
                    className="block w-full h-full"
                    style={{ fill: "white", stroke: "none" }}
                  >
                    <defs className="">
                      <path
                        d="M5.625 19.25c.77 0 1.375.605 1.375 1.375S6.395 22 5.625 22s-1.375-.605-1.375-1.375.605-1.375 1.375-1.375zm13 0c.77 0 1.375.605 1.375 1.375S19.395 22 18.625 22s-1.375-.605-1.375-1.375.604-1.375 1.375-1.375zM1.135 2.212l2.962.543 18.762 2.622-2.29 7.853-13.855.492.368 2.167c.094.558.55.977 1.103 1.034l.13.007H20.25v1.5H8.314a2.75 2.75 0 01-2.677-2.12l-.034-.17-.427-2.514L3.36 4.144.865 3.688l.27-1.476zm3.798 2.175l1.503 7.844 12.996-.462 1.5-5.147-16-2.235z"
                        id="nds-Icon2485a"
                        className=""
                      />
                    </defs>
                    <g fill="none" fillRule="evenodd" className="">
                      <mask id="nds-Icon2485b" fill="#fff" className="">
                        <use xlinkHref="#nds-Icon2485a" className="" />
                      </mask>
                      <use
                        fill="#333"
                        fillRule="nonzero"
                        xlinkHref="#nds-Icon2485a"
                        className=""
                      />
                      <g mask="url(#nds-Icon2485b)" fill="#333" className="">
                        <path d="M0 0h24v24H0z" className="" />
                      </g>
                    </g>
                  </svg>
                </div>
              </span>
            </div>
          </div>
        </nav>
        <div
          className="absolute lg:hidden"
          style={{
            outline: 0,
            top: 64,
            left: 16,
            right: 16,
            zIndex: 1050,
            transition:
              "top 0.4s ease-in-out 0s, left 0.4s ease-out 0s, opacity 0.4s ease-in-out 0.4s, width 0.4s ease-in-out 0s",
          }}
        >
          <div className="relative md:hidden" style={{ outline: 0 }}>
            <button
              aria-label="Search"
              type="button"
              style={{ width: "100%", boxShadow: "none" }}
              className="p-0 m-0 w-full text-center normal-case align-middle bg-transparent border-0 cursor-pointer focus:outline-offset-2"
            >
              <form className="flex relative p-0 m-0 w-full h-10 rounded-lg md:h-10 md:pl-0 bg-neutral-100">
                <input
                  data-test="@web/SearchInputMobile"
                  placeholder="Search"
                  readOnly=""
                  tabIndex={-1}
                  type="text"
                  className="flex relative py-0 pr-10 pl-3 m-0 w-full text-base rounded-none border-0 appearance-none cursor-text resize-none md:py-3 md:pr-20 md:pl-3 box-border"
                  defaultValue=""
                  style={{ outline: "none" }}
                />
              </form>
            </button>
          </div>
        </div>
      </div>
      {/* SECCION */}
      <div
        className="text-sm leading-5 text-zinc-800 ml-4"
        data-test="@web/Breadcrumb/Container"
        style={{ outline: 0 }}
      >
        <span className="leading-5" style={{ outline: 0 }}>
          <span className="text-zinc-800" style={{ outline: 0 }}>
            <a
              href="/"
              className="overflow-visible relative p-0 align-baseline bg-transparent border-0 cursor-pointer text-stone-500 focus:text-zinc-800 focus:outline-dashed focus:outline-1 hover:text-zinc-800"
              aria-label="Target"
              data-test="@web/Breadcrumb/BreadcrumbLink"
              itemProp="url"
              style={{ textDecoration: "underline", boxShadow: "none" }}
            >
              <span
                aria-hidden="true"
                itemProp="name"
                className=""
                style={{ outline: 0 }}
              >
                Target
              </span>
            </a>
          </span>
          <span
            aria-hidden="true"
            className="px-1 text-zinc-800"
            style={{ outline: 0 }}
          >
            /
          </span>
        </span>
        <span className="leading-5" style={{ outline: 0 }}>
          <span className="text-zinc-800" style={{ outline: 0 }}>
            <a
              href="/c/movies-music-books/-/N-5xsxe"
              className="overflow-visible relative p-0 align-baseline bg-transparent border-0 cursor-pointer text-stone-500 focus:text-zinc-800 focus:outline-dashed focus:outline-1 hover:text-zinc-800"
              aria-label="Movies, Music & Books"
              data-test="@web/Breadcrumb/BreadcrumbLink"
              itemProp="url"
              style={{ textDecoration: "underline", boxShadow: "none" }}
            >
              <span
                aria-hidden="true"
                itemProp="name"
                className=""
                style={{ outline: 0 }}
              >
                Sports
              </span>
            </a>
          </span>
          <span
            aria-hidden="true"
            className="px-1 text-zinc-800"
            style={{ outline: 0 }}
          >
            /
          </span>
        </span>
        <span className="leading-5" style={{ outline: 0 }}>
          <span className="text-zinc-800" style={{ outline: 0 }}>
            <a
              href="/c/books-movies-music/-/N-5xsxd"
              className="overflow-visible relative p-0 align-baseline bg-transparent border-0 cursor-pointer text-stone-500 focus:text-zinc-800 focus:outline-dashed focus:outline-1 hover:text-zinc-800"
              aria-label="Books"
              data-test="@web/Breadcrumb/BreadcrumbLink"
              itemProp="url"
              style={{ textDecoration: "underline", boxShadow: "none" }}
            >
              <span
                aria-hidden="true"
                itemProp="name"
                className=""
                style={{ outline: 0 }}
              >
                T-Shirt
              </span>
            </a>
          </span>
          <span
            aria-hidden="true"
            className="px-1 text-zinc-800"
            style={{ outline: 0 }}
          >
            /
          </span>
        </span>
        <span className="leading-5" style={{ outline: 0 }}>
          <span className="text-zinc-800" style={{ outline: 0 }}>
            <a
              href="/c/non-fiction-books-movies-music/-/N-ctps8"
              className="overflow-visible relative p-0 align-baseline bg-transparent border-0 cursor-pointer text-stone-500 focus:text-zinc-800 focus:outline-dashed focus:outline-1 hover:text-zinc-800"
              aria-label="Non-Fiction"
              data-test="@web/Breadcrumb/BreadcrumbLink"
              itemProp="url"
              style={{ textDecoration: "underline", boxShadow: "none" }}
            >
              <span
                aria-hidden="true"
                itemProp="name"
                className=""
                style={{ outline: 0 }}
              >
                Checo Perez
              </span>
            </a>
          </span>
          <span
            aria-hidden="true"
            className="text-zinc-800"
            style={{ outline: 0 }}
          ></span>
        </span>
      </div>
      {/* SECCION
       */}
      <h1
        className="mx-0 ml-4 mt-6 mb-2 font-sans text-lg not-italic tracking-normal leading-tight normal-case align-baseline whitespace-normal indent-0 text-zinc-800"
        data-test="product-title"
        tabIndex={-1}
        style={{ outline: 0, fontWeight: "bold", textShadow: "none" }}
      >
        <span className="text-lg font-bold leading-6" style={{ outline: 0 }}>
          Red Bull Racing - Official Formula 1 Merchandise - Sergio Perez Checo
          T-Shirt - Men - Navy - L
        </span>
      </h1>
      {/* SECCION */}
      <div
        className={
          window.innerWidth <= 1024 ? "flex flex-col" : "flex flex-row"
        }
      >
        <img
          src="https://m.media-amazon.com/images/I/515OA1NDqZL._AC_UL1500_.jpg"
          className="mx-auto h-56 my-4"
          alt=""
          srcSet=""
        />
        <div
          className="flex-row flex-grow-0 flex-shrink px-0 leading-6 box-border text-zinc-800 lg:flex-shrink-0 mx-4"
          style={{ outline: 0, flexBasis: 384 }}
        >
          <div
            className="mt-5 mb-8 w-full sm:mt-0"
            style={{ outline: 0, maxWidth: 352 }}
          >
            <div className="mb-2 text-zinc-800" style={{ outline: 0 }}>
              <div className="" style={{ outline: 0 }}>
                <span
                  data-test="product-price"
                  className="inline-block text-lg leading-7 lg:text-2xl"
                  style={{ outline: 0, fontWeight: "bold" }}
                >
                  $50.00
                </span>
                <button
                  className="overflow-visible relative p-0 my-0 mr-0 ml-2 text-xs text-center normal-case align-baseline bg-transparent border-0 cursor-pointer text-stone-500 focus:text-zinc-800 hover:text-zinc-800"
                  type="button"
                  style={{ boxShadow: "none", textDecoration: "underline" }}
                >
                  <span
                    data-test="product-price-msrp"
                    className="leading-4"
                    style={{ outline: 0 }}
                  >
                    MSRP $17.00{" "}
                  </span>
                  <span
                    className="leading-4"
                    data-test="product-savings-amount"
                    style={{ outline: 0 }}
                  >
                    Save $4.21 (25% off)
                  </span>
                </button>
              </div>
              <div
                className="flex items-center mt-1"
                data-test="@web/ProductCardPriceLocation"
                style={{ outline: 0 }}
              >
                <span className="text-xs leading-4" style={{ outline: 0 }}>
                  When purchased online
                </span>
                <button
                  aria-label="More info about pricing"
                  className="flex p-0 m-0 text-center normal-case align-middle bg-none cursor-pointer focus:text-stone-500 focus:outline-offset-2"
                  type="button"
                  style={{ boxShadow: "none" }}
                >
                  <span
                    className="inline-block flex-shrink-0 w-4 h-4 font-sans text-base not-italic tracking-normal text-black normal-case align-baseline whitespace-normal indent-0"
                    data-icon-name="AlertsInfoCircle"
                    fill="#000000"
                    size={18}
                    style={{
                      outline: 0,
                      fill: "rgb(0, 0, 0)",
                      lineHeight: "1.4285",
                      fontWeight: "normal",
                      textShadow: "none",
                    }}
                  >
                    <div className="w-full h-full" style={{ outline: 0 }}>
                      <svg
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        focusable="false"
                        role="presentation"
                        className="block w-full h-full"
                        style={{ fill: "white", stroke: "none" }}
                      >
                        <g fill="none" fillRule="evenodd" className="">
                          <path
                            d="M12 23.5C5.649 23.5.5 18.351.5 12S5.649.5 12 .5 23.5 5.649 23.5 12 18.351 23.5 12 23.5z"
                            className=""
                          />
                          <path
                            d="M12 .5C18.351.5 23.5 5.649 23.5 12S18.351 23.5 12 23.5.5 18.351.5 12 5.649.5 12 .5zM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm.75 7.75V18h-1.5V9.75h1.5zM12 6.5a1.12 1.12 0 110 2.24 1.12 1.12 0 010-2.24z"
                            fill="#666"
                            fillRule="nonzero"
                            className=""
                          />
                        </g>
                      </svg>
                    </div>
                  </span>
                </button>
              </div>
            </div>
            <div
              className="flex justify-between mb-4 text-zinc-800"
              style={{ outline: 0 }}
            >
              <div
                className="flex"
                data-test="ratingFeedbackContainer"
                style={{ outline: 0 }}
              >
                <div
                  className="flex overflow-visible relative p-0 mr-1 align-baseline bg-transparent border-0 cursor-pointer text-stone-500 focus:text-zinc-800 focus:outline-dashed focus:outline-1 hover:text-zinc-800"
                  aria-haspopup="true"
                  data-test="ratingCountLink"
                  id="ratingReviewId"
                  style={{ textDecoration: "underline", boxShadow: "none" }}
                >
                  <div className="flex items-center" style={{ outline: 0 }}>
                    <span
                      className="inline-flex relative text-lg align-bottom"
                      data-test="ratings"
                      style={{ outline: 0, lineHeight: "normal" }}
                    >
                      <span
                        className="inline-block overflow-hidden absolute p-0 -m-px w-px h-px"
                        style={{ outline: 0, clip: "rect(0px, 0px, 0px, 0px)" }}
                      >
                        4.9 out of 5 stars with 16 reviews
                      </span>
                      <svg
                        size={18}
                        preserveAspectRatio="xMinYMin meet"
                        version="1.1"
                        viewBox="0 0 5 50"
                        xmlnsXlink="http://www.w3.org/2000/svg"
                        className="w-24 h-4"
                      >
                        <g className="">
                          <polygon
                            className=""
                            fill="#fff"
                            points="18.3804527 17.5538712 3.57341884 17.5538227 15.5524968 26.0839651 10.9490362 39.9740092 22.9998469 31.3908403 35.0505989 39.9718199 30.4479632 26.0860159 42.4267599 17.5548252 27.6195159 17.5548252 22.9999796 3.61638342"
                            transform="translate(200, 0)"
                          />
                          <path
                            className=""
                            d="M23,0.125 C23.548595,0.125 24.0427295,0.43633439 24.2838822,0.916322114 L24.3620682,1.10394446 L29.1238205,15.4714919 L44.4834654,15.4714919 C45.1040547,15.4669374 45.6559866,15.865131 45.847289,16.4554281 C46.0385914,17.0457252 45.8251153,17.6918966 45.3197896,18.0521171 L32.9094637,26.8906392 L37.659289,41.2205029 C37.8492978,41.8088537 37.6399199,42.4526832 37.1401666,42.8167858 C36.6404132,43.1808884 35.963305,43.1829213 35.4613737,42.8218261 L23,33.9484823 L10.5391034,42.8237342 C10.0368835,43.1855662 9.35893267,43.1835738 8.85884877,42.8187963 C8.35876487,42.4540187 8.14989861,41.8091377 8.34118809,41.2205029 L13.0910134,26.8887312 L0.680210361,18.0511631 C0.174884727,17.6909426 -0.0385914063,17.0447712 0.152710977,16.4544741 C0.34401336,15.864177 0.89594535,15.4659834 1.51653456,15.4705379 L16.8761795,15.4705379 L21.6379318,1.10394446 C21.8345878,0.519032587 22.3828306,0.125 23,0.125 Z M22.9999796,3.61638342 L18.3804527,17.5538712 L3.57341884,17.5538227 L15.5524968,26.0839651 L10.9490362,39.9740092 L22.9998469,31.3908403 L35.0505989,39.9718199 L30.4479632,26.0860159 L42.4267599,17.5548252 L27.6195159,17.5548252 L22.9999796,3.61638342 Z"
                            fill="#888"
                            transform="translate(200, 0)"
                          />
                        </g>
                      </svg>
                      <div
                        data-ref="rating-mask"
                        className="overflow-hidden absolute top-0 left-0"
                        style={{ width: "96%", outline: 0 }}
                      >
                        <svg
                          focusable="false"
                          size={18}
                          tabIndex={-1}
                          preserveAspectRatio="xMinYMin meet"
                          version="1.1"
                          viewBox="0 0 5 50"
                          xmlnsXlink="http://www.w3.org/2000/svg"
                          className="w-24 h-4"
                          style={{ outline: 0 }}
                        >
                          <g className="">
                            <polygon
                              className=""
                              fill="#ffd700"
                              points="18.3804527 17.5538712 3.57341884 17.5538227 15.5524968 26.0839651 10.9490362 39.9740092 22.9998469 31.3908403 35.0505989 39.9718199 30.4479632 26.0860159 42.4267599 17.5548252 27.6195159 17.5548252 22.9999796 3.61638342"
                            />
                            <path
                              className=""
                              d="M23,0.125 C23.548595,0.125 24.0427295,0.43633439 24.2838822,0.916322114 L24.3620682,1.10394446 L29.1238205,15.4714919 L44.4834654,15.4714919 C45.1040547,15.4669374 45.6559866,15.865131 45.847289,16.4554281 C46.0385914,17.0457252 45.8251153,17.6918966 45.3197896,18.0521171 L32.9094637,26.8906392 L37.659289,41.2205029 C37.8492978,41.8088537 37.6399199,42.4526832 37.1401666,42.8167858 C36.6404132,43.1808884 35.963305,43.1829213 35.4613737,42.8218261 L23,33.9484823 L10.5391034,42.8237342 C10.0368835,43.1855662 9.35893267,43.1835738 8.85884877,42.8187963 C8.35876487,42.4540187 8.14989861,41.8091377 8.34118809,41.2205029 L13.0910134,26.8887312 L0.680210361,18.0511631 C0.174884727,17.6909426 -0.0385914063,17.0447712 0.152710977,16.4544741 C0.34401336,15.864177 0.89594535,15.4659834 1.51653456,15.4705379 L16.8761795,15.4705379 L21.6379318,1.10394446 C21.8345878,0.519032587 22.3828306,0.125 23,0.125 Z M22.9999796,3.61638342 L18.3804527,17.5538712 L3.57341884,17.5538227 L15.5524968,26.0839651 L10.9490362,39.9740092 L22.9998469,31.3908403 L35.0505989,39.9718199 L30.4479632,26.0860159 L42.4267599,17.5548252 L27.6195159,17.5548252 L22.9999796,3.61638342 Z"
                              fill="#ca8600"
                            />
                          </g>
                          <g className="">
                            <polygon
                              className=""
                              fill="#ffd700"
                              points="18.3804527 17.5538712 3.57341884 17.5538227 15.5524968 26.0839651 10.9490362 39.9740092 22.9998469 31.3908403 35.0505989 39.9718199 30.4479632 26.0860159 42.4267599 17.5548252 27.6195159 17.5548252 22.9999796 3.61638342"
                              transform="translate(50, 0)"
                            />
                            <path
                              className=""
                              d="M23,0.125 C23.548595,0.125 24.0427295,0.43633439 24.2838822,0.916322114 L24.3620682,1.10394446 L29.1238205,15.4714919 L44.4834654,15.4714919 C45.1040547,15.4669374 45.6559866,15.865131 45.847289,16.4554281 C46.0385914,17.0457252 45.8251153,17.6918966 45.3197896,18.0521171 L32.9094637,26.8906392 L37.659289,41.2205029 C37.8492978,41.8088537 37.6399199,42.4526832 37.1401666,42.8167858 C36.6404132,43.1808884 35.963305,43.1829213 35.4613737,42.8218261 L23,33.9484823 L10.5391034,42.8237342 C10.0368835,43.1855662 9.35893267,43.1835738 8.85884877,42.8187963 C8.35876487,42.4540187 8.14989861,41.8091377 8.34118809,41.2205029 L13.0910134,26.8887312 L0.680210361,18.0511631 C0.174884727,17.6909426 -0.0385914063,17.0447712 0.152710977,16.4544741 C0.34401336,15.864177 0.89594535,15.4659834 1.51653456,15.4705379 L16.8761795,15.4705379 L21.6379318,1.10394446 C21.8345878,0.519032587 22.3828306,0.125 23,0.125 Z M22.9999796,3.61638342 L18.3804527,17.5538712 L3.57341884,17.5538227 L15.5524968,26.0839651 L10.9490362,39.9740092 L22.9998469,31.3908403 L35.0505989,39.9718199 L30.4479632,26.0860159 L42.4267599,17.5548252 L27.6195159,17.5548252 L22.9999796,3.61638342 Z"
                              fill="#ca8600"
                              transform="translate(50, 0)"
                            />
                          </g>
                          <g className="">
                            <polygon
                              className=""
                              fill="#ffd700"
                              points="18.3804527 17.5538712 3.57341884 17.5538227 15.5524968 26.0839651 10.9490362 39.9740092 22.9998469 31.3908403 35.0505989 39.9718199 30.4479632 26.0860159 42.4267599 17.5548252 27.6195159 17.5548252 22.9999796 3.61638342"
                              transform="translate(100, 0)"
                            />
                            <path
                              className=""
                              d="M23,0.125 C23.548595,0.125 24.0427295,0.43633439 24.2838822,0.916322114 L24.3620682,1.10394446 L29.1238205,15.4714919 L44.4834654,15.4714919 C45.1040547,15.4669374 45.6559866,15.865131 45.847289,16.4554281 C46.0385914,17.0457252 45.8251153,17.6918966 45.3197896,18.0521171 L32.9094637,26.8906392 L37.659289,41.2205029 C37.8492978,41.8088537 37.6399199,42.4526832 37.1401666,42.8167858 C36.6404132,43.1808884 35.963305,43.1829213 35.4613737,42.8218261 L23,33.9484823 L10.5391034,42.8237342 C10.0368835,43.1855662 9.35893267,43.1835738 8.85884877,42.8187963 C8.35876487,42.4540187 8.14989861,41.8091377 8.34118809,41.2205029 L13.0910134,26.8887312 L0.680210361,18.0511631 C0.174884727,17.6909426 -0.0385914063,17.0447712 0.152710977,16.4544741 C0.34401336,15.864177 0.89594535,15.4659834 1.51653456,15.4705379 L16.8761795,15.4705379 L21.6379318,1.10394446 C21.8345878,0.519032587 22.3828306,0.125 23,0.125 Z M22.9999796,3.61638342 L18.3804527,17.5538712 L3.57341884,17.5538227 L15.5524968,26.0839651 L10.9490362,39.9740092 L22.9998469,31.3908403 L35.0505989,39.9718199 L30.4479632,26.0860159 L42.4267599,17.5548252 L27.6195159,17.5548252 L22.9999796,3.61638342 Z"
                              fill="#ca8600"
                              transform="translate(100, 0)"
                            />
                          </g>
                          <g className="">
                            <polygon
                              className=""
                              fill="#ffd700"
                              points="18.3804527 17.5538712 3.57341884 17.5538227 15.5524968 26.0839651 10.9490362 39.9740092 22.9998469 31.3908403 35.0505989 39.9718199 30.4479632 26.0860159 42.4267599 17.5548252 27.6195159 17.5548252 22.9999796 3.61638342"
                              transform="translate(150, 0)"
                            />
                            <path
                              className=""
                              d="M23,0.125 C23.548595,0.125 24.0427295,0.43633439 24.2838822,0.916322114 L24.3620682,1.10394446 L29.1238205,15.4714919 L44.4834654,15.4714919 C45.1040547,15.4669374 45.6559866,15.865131 45.847289,16.4554281 C46.0385914,17.0457252 45.8251153,17.6918966 45.3197896,18.0521171 L32.9094637,26.8906392 L37.659289,41.2205029 C37.8492978,41.8088537 37.6399199,42.4526832 37.1401666,42.8167858 C36.6404132,43.1808884 35.963305,43.1829213 35.4613737,42.8218261 L23,33.9484823 L10.5391034,42.8237342 C10.0368835,43.1855662 9.35893267,43.1835738 8.85884877,42.8187963 C8.35876487,42.4540187 8.14989861,41.8091377 8.34118809,41.2205029 L13.0910134,26.8887312 L0.680210361,18.0511631 C0.174884727,17.6909426 -0.0385914063,17.0447712 0.152710977,16.4544741 C0.34401336,15.864177 0.89594535,15.4659834 1.51653456,15.4705379 L16.8761795,15.4705379 L21.6379318,1.10394446 C21.8345878,0.519032587 22.3828306,0.125 23,0.125 Z M22.9999796,3.61638342 L18.3804527,17.5538712 L3.57341884,17.5538227 L15.5524968,26.0839651 L10.9490362,39.9740092 L22.9998469,31.3908403 L35.0505989,39.9718199 L30.4479632,26.0860159 L42.4267599,17.5548252 L27.6195159,17.5548252 L22.9999796,3.61638342 Z"
                              fill="#ca8600"
                              transform="translate(150, 0)"
                            />
                          </g>
                          <g className="">
                            <polygon
                              className=""
                              fill="#ffd700"
                              points="18.3804527 17.5538712 3.57341884 17.5538227 15.5524968 26.0839651 10.9490362 39.9740092 22.9998469 31.3908403 35.0505989 39.9718199 30.4479632 26.0860159 42.4267599 17.5548252 27.6195159 17.5548252 22.9999796 3.61638342"
                              transform="translate(200, 0)"
                            />
                            <path
                              className=""
                              d="M23,0.125 C23.548595,0.125 24.0427295,0.43633439 24.2838822,0.916322114 L24.3620682,1.10394446 L29.1238205,15.4714919 L44.4834654,15.4714919 C45.1040547,15.4669374 45.6559866,15.865131 45.847289,16.4554281 C46.0385914,17.0457252 45.8251153,17.6918966 45.3197896,18.0521171 L32.9094637,26.8906392 L37.659289,41.2205029 C37.8492978,41.8088537 37.6399199,42.4526832 37.1401666,42.8167858 C36.6404132,43.1808884 35.963305,43.1829213 35.4613737,42.8218261 L23,33.9484823 L10.5391034,42.8237342 C10.0368835,43.1855662 9.35893267,43.1835738 8.85884877,42.8187963 C8.35876487,42.4540187 8.14989861,41.8091377 8.34118809,41.2205029 L13.0910134,26.8887312 L0.680210361,18.0511631 C0.174884727,17.6909426 -0.0385914063,17.0447712 0.152710977,16.4544741 C0.34401336,15.864177 0.89594535,15.4659834 1.51653456,15.4705379 L16.8761795,15.4705379 L21.6379318,1.10394446 C21.8345878,0.519032587 22.3828306,0.125 23,0.125 Z M22.9999796,3.61638342 L18.3804527,17.5538712 L3.57341884,17.5538227 L15.5524968,26.0839651 L10.9490362,39.9740092 L22.9998469,31.3908403 L35.0505989,39.9718199 L30.4479632,26.0860159 L42.4267599,17.5548252 L27.6195159,17.5548252 L22.9999796,3.61638342 Z"
                              fill="#ca8600"
                              transform="translate(200, 0)"
                            />
                          </g>
                        </svg>
                      </div>
                    </span>
                  </div>
                  <span
                    className="ml-1 text-xs leading-4 align-text-top"
                    style={{ outline: 0 }}
                  >
                    <span
                      aria-hidden="true"
                      className="leading-5"
                      style={{ outline: 0 }}
                    >
                      16
                    </span>
                  </span>
                  <span
                    className="inline-block overflow-hidden absolute -m-px w-px h-px"
                    style={{ outline: 0, clip: "rect(0px, 0px, 0px, 0px)" }}
                  >
                    <span className="" style={{ outline: 0 }}>
                      <span
                        aria-hidden="true"
                        className=""
                        style={{ outline: 0 }}
                      >
                        16
                      </span>
                    </span>
                    <span
                      aria-hidden="true"
                      className=""
                      style={{ outline: 0 }}
                    >
                      ratings
                    </span>
                  </span>
                  <span className="ml-1" style={{ outline: 0 }}>
                    <span
                      className="inline-block flex-shrink-0 w-4 h-4 font-sans text-base not-italic tracking-normal normal-case align-baseline whitespace-normal indent-0"
                      data-icon-name="NavigationArrowDownFill"
                      fill="#333333"
                      size={16}
                      data-test="ratingHistogramDropDown"
                      style={{
                        outline: 0,
                        fill: "rgb(51, 51, 51)",
                        lineHeight: "1.4285",
                        fontWeight: "normal",
                        textShadow: "none",
                      }}
                    >
                      <div className="w-full h-full" style={{ outline: 0 }}>
                        <svg
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          focusable="false"
                          role="presentation"
                          className="block w-full h-full"
                          style={{ fill: "white", stroke: "none" }}
                        >
                          <defs className="">
                            <path
                              id="nds-Icon2133a"
                              d="M9.06 12.5l7.47-7.47-1.06-1.06-8.53 8.53 8.53 8.53 1.06-1.06z"
                              className=""
                            />
                          </defs>
                          <use
                            transform="scale(1 -1) rotate(90 24.235 0)"
                            xlinkHref="#nds-Icon2133a"
                            className=""
                          />
                        </svg>
                      </div>
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div className="my-4 text-zinc-800" style={{ outline: 0 }} />
            <div className="mb-8 text-zinc-800" style={{ outline: 0 }}>
              <div
                data-test="@web/AddToCart/FulfillmentSection"
                className=""
                style={{ outline: 0, maxWidth: 444 }}
              >
                <div className="" style={{ outline: 0, fontWeight: "bold" }}>
                  There was a temporary issue
                </div>
                <div
                  className="text-sm leading-5 text-stone-500"
                  style={{ outline: 0 }}
                >
                  Choose delivery method in cart
                </div>
                <div className="mt-4" style={{ outline: 0 }}>
                  <div style={{ display: "flex", outline: 0 }} className="flex">
                    <div className="flex-shrink-0 mr-4" style={{ outline: 0 }}>
                      <div className="" style={{ outline: 0 }}>
                        <button
                          type="button"
                          aria-expanded="false"
                          id="select-1788"
                          className="inline-flex relative justify-center items-center py-0 px-3 m-0 h-10 font-sans text-base not-italic tracking-normal leading-none text-center normal-case align-middle bg-white rounded border border-solid cursor-pointer select-none box-border truncate border-zinc-500 indent-0 focus:outline-offset-2 hover:border-zinc-800 hover:bg-neutral-100 hover:text-zinc-800"
                          style={{
                            boxShadow: "none",
                            fontWeight: "normal",
                            textShadow: "none",
                            textDecoration: "none",
                          }}
                        >
                          <div
                            className="flex flex-initial leading-4 whitespace-nowrap box-border"
                            style={{ outline: 0, flexFlow: "row nowrap" }}
                          >
                            <div
                              textLength={4}
                              className="flex flex-row flex-none px-0 box-border"
                              style={{ outline: 0 }}
                            >
                              <span
                                className="flex pr-1"
                                style={{ outline: 0 }}
                              >
                                Qty
                              </span>
                              <div
                                className="py-0 px-1"
                                style={{ outline: 0, fontWeight: "bold" }}
                              >
                                1
                              </div>
                            </div>
                            <div
                              className="flex-row flex-none px-0 text-xs leading-3 text-right box-border"
                              style={{ outline: 0 }}
                            >
                              <span
                                aria-expanded="false"
                                className="flex ml-2"
                                style={{ outline: 0 }}
                              >
                                <svg
                                  height={14}
                                  viewBox="0 0 23 23"
                                  width={14}
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="inline-block align-middle"
                                  style={{ maxWidth: 20 }}
                                >
                                  <path
                                    d="M12.002 15.38l9.589-9.588 1.414 1.414-11.003 11.002L1 7.206l1.414-1.414z"
                                    fill="#888"
                                    className=""
                                    style={{ fill: "currentcolor" }}
                                  />
                                </svg>
                              </span>
                            </div>
                          </div>
                        </button>
                      </div>
                    </div>
                    <button
                      type="button"
                      aria-label="Add to cart for To Selena, with Love - by  Chris Perez (Paperback)"
                      data-test="shippingButton"
                      id="addToCartButtonOrTextIdFor77262583"
                      className="inline-flex relative justify-center items-center py-0 px-3 m-0 w-full h-10 font-sans text-base not-italic tracking-normal leading-none text-center text-white normal-case align-middle bg-red-700 rounded border border-red-700 border-solid cursor-pointer select-none box-border truncate indent-0 focus:outline-offset-2 hover:border-red-800 hover:bg-red-800 hover:text-white"
                      style={{
                        boxShadow: "none",
                        fontWeight: "bold",
                        textShadow: "none",
                        textDecoration: "none",
                      }}
                      onClick={() => navigate("/checkouttarget")}
                    >
                      Add to cart
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="text-zinc-800" style={{ outline: 0 }}>
              <div className="flex items-center" style={{ outline: 0 }}>
                <span
                  className="inline-block flex-shrink-0 w-8 h-8 font-sans text-base not-italic tracking-normal text-black normal-case align-baseline whitespace-normal indent-0"
                  data-icon-name="GeneralGiftRegistryRed"
                  fill="#000000"
                  size={30}
                  style={{
                    outline: 0,
                    fill: "rgb(0, 0, 0)",
                    lineHeight: "1.4285",
                    fontWeight: "normal",
                    textShadow: "none",
                  }}
                >
                  <div className="w-full h-full" style={{ outline: 0 }}>
                    <svg
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      focusable="false"
                      role="presentation"
                      className="block w-full h-full"
                      style={{ fill: "white", stroke: "none" }}
                    >
                      <g fill="none" fillRule="evenodd" className="">
                        <path
                          d="M21.5 7v3.25h-1V22.5h-17V10.25h-1V7h19z"
                          fill="#C00"
                          className=""
                        />
                        <path
                          d="M20.5 10.25v1.25h-17v-1.25h17zm-7.082-7.739c.694-.772 1.746-1.143 2.739-.969A2.505 2.505 0 0118.086 3.1a2.944 2.944 0 01-.17 2.56c-.411.712-1.091 1.184-1.866 1.292-.327.045-.652.043-.935.045L14.829 7h-.159c-.38 0-1.332-.007-2.064-.013-.194 0-.365-.003-.512-.003h-.11c-.155.001-.356.003-.588.003-.793.006-1.848.013-2.15.013h-.074l-.286-.003c-.287 0-.608 0-.933-.044-.777-.109-1.458-.58-1.868-1.293a2.944 2.944 0 01-.171-2.56 2.508 2.508 0 011.93-1.558c.994-.173 2.045.198 2.738.97.439.49.924 1.09 1.418 1.746.494-.656.979-1.256 1.418-1.747zm2.449.69c-.421-.072-.891.097-1.195.434-.42.467-.883 1.04-1.36 1.673l1.488.007.316-.002c.26.004.492.001.7-.029.257-.035.49-.205.642-.465.186-.325.21-.73.068-1.087a.822.822 0 00-.66-.53zm-7.592-.015l-.142.015a.821.821 0 00-.658.532c-.145.355-.12.761.068 1.086.089.152.289.416.643.466.208.028.448.028.698.028l.319.002c.084-.002.778-.003 1.485-.007a26.23 26.23 0 00-1.36-1.673c-.304-.338-.772-.508-1.195-.434z"
                          fill="#840000"
                          className=""
                        />
                        <path
                          d="M12 13.25c1.93 0 3.5 1.57 3.5 3.5s-1.57 3.5-3.5 3.5-3.5-1.57-3.5-3.5 1.57-3.5 3.5-3.5zm0 1.166l-.16.005a2.333 2.333 0 00.16 4.662l.16-.005a2.333 2.333 0 00-.16-4.662zm0 1.167a1.166 1.166 0 110 2.333 1.166 1.166 0 010-2.333z"
                          fill="#FFF"
                          className=""
                        />
                      </g>
                    </svg>
                  </div>
                </span>
                <div className="mx-2" style={{ outline: 0 }}>
                  <div className="" style={{ outline: 0 }}>
                    Create or manage registry
                  </div>
                </div>
                <button
                  type="button"
                  aria-label="sign in to add item to registry"
                  data-test="registryListButton"
                  className="inline-flex relative justify-center items-center py-0 px-3 my-0 mr-0 ml-auto h-10 font-sans text-base not-italic tracking-normal leading-none text-center normal-case align-middle bg-white rounded border border-solid cursor-pointer select-none box-border truncate border-zinc-500 indent-0 focus:outline-offset-2 hover:border-zinc-800 hover:bg-neutral-100 hover:text-zinc-800"
                  style={{
                    boxShadow: "none",
                    fontWeight: "normal",
                    textShadow: "none",
                    textDecoration: "none",
                  }}
                >
                  <span
                    className="ml-1 leading-4 whitespace-nowrap"
                    style={{ outline: 0 }}
                  >
                    Sign in
                  </span>
                </button>
              </div>
            </div>
            <div
              data-test="circle-offers-pdp"
              className="text-zinc-800"
              style={{ outline: 0 }}
            />
            <div
              data-test="circle-offers-pdp"
              className="text-zinc-800"
              style={{ outline: 0 }}
            />
            <div
              data-test="affirm-financing-options-block"
              className="mx-auto mb-1 w-full text-zinc-800"
              style={{ outline: 0, maxWidth: 1400 }}
            >
              <div
                className="flex flex-initial items-center my-3 box-border"
                data-test="redcard-financing-block"
                style={{ outline: 0, flexFlow: "row wrap" }}
              >
                <div
                  className="flex-row flex-none px-0 box-border"
                  style={{ outline: 0 }}
                >
                  <div
                    className="flex justify-center items-center"
                    style={{ outline: 0 }}
                  >
                    <span
                      className="inline-block flex-shrink-0 mt-1 w-8 h-8 font-sans text-base not-italic tracking-normal text-black normal-case align-baseline whitespace-normal indent-0"
                      data-icon-name="PaymentREDcardCredit"
                      fill="#000000"
                      height="32px"
                      width="32px"
                      style={{
                        outline: 0,
                        fill: "rgb(0, 0, 0)",
                        lineHeight: "1.4285",
                        fontWeight: "normal",
                        textShadow: "none",
                      }}
                    >
                      <div className="w-full h-full" style={{ outline: 0 }}>
                        <svg
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          focusable="false"
                          role="presentation"
                          className="block w-full h-full"
                          style={{ fill: "white", stroke: "none" }}
                        >
                          <g
                            transform="translate(.438 4)"
                            fill="none"
                            fillRule="evenodd"
                            className=""
                          >
                            <rect
                              fill="#C00"
                              fillRule="nonzero"
                              transform="rotate(-90 11.563 8)"
                              x="4.063"
                              y={-3}
                              width={15}
                              height={22}
                              rx="1.499"
                              className=""
                            />
                            <g transform="translate(3.308 5.565)" className="">
                              <rect
                                fill="#BF6C30"
                                width="2.516"
                                height="2.006"
                                rx=".143"
                                className=""
                              />
                              <path
                                d="M.4778 1.337h.666v.227l-.6658.0004-.0002-.2275zm1.56 0l.0007.2274-.6667-.0005v-.227h.666zm0-.446v.223h-1.56V.891h1.56zm0-.223h-.666V.442h.6667l-.0007.226zm-.894-.226v.226h-.666L.478.442h.6658z"
                                fill="#F2DA78"
                                className=""
                              />
                            </g>
                            <path
                              d="M15.5883 3.1875c.257 0 .4697.1488.5303.4025l.0135.0792h-.2683c-.0196-.1313-.1377-.2342-.2755-.2342-.2259 0-.3423.1892-.3423.459 0 .2513.1111.448.3423.448.1391 0 .2361-.0833.2736-.2321l.0124-.0678h.2684c-.0283.3374-.2455.5472-.5544.5472-.3848 0-.6196-.3036-.6196-.6953 0-.3954.2296-.7065.6196-.7065zm1.7745.3749c.2639 0 .4176.2015.4414.456l.0033.0707-.0016.0485h-.6584c.007.1669.0793.2455.2223.2455.0795 0 .1515-.0403.1846-.0927l.015-.0328h.2206c-.0671.2192-.2084.3261-.4272.3261-.2895 0-.466-.2117-.466-.5096 0-.2925.1906-.5117.466-.5117zm1.4551-.343v1.3381h-.2384v-.1237c-.0583.0994-.1554.15-.2806.15-.2718 0-.4096-.2436-.4096-.5192 0-.268.1413-.5021.4043-.5021.0874 0 .1728.0324.2315.0932l.0385.051h.0035v-.4874h.2508zm.8736.0787v.2906h.1835v.178h-.1835v.4798c0 .09.021.1123.106.1123l.0413-.0017.0362-.0058v.2081c-.0424.0075-.0989.0094-.1484.0094-.1682 0-.261-.0474-.2815-.1748l-.0044-.0596v-.5678h-.1517v-.178h.1517v-.2905h.2508zm-2.8823.2642l.032.0033.0227.006v.2476a.407.407 0 00-.09-.0094c-.1616 0-.2312.105-.2446.2535l-.0025.0576v.4367h-.2506v-.9689h.2382v.1799c.0512-.122.1694-.2063.2948-.2063zm2.3974.0263v.9689h-.2506v-.9689h.2506zm-.8477.1743c-.1429 0-.2188.1219-.2188.3092 0 .1537.067.311.2206.311.143 0 .2153-.1179.2153-.3129 0-.176-.0636-.3073-.217-.3073zm-1.005-.0001c-.1044 0-.1737.0579-.198.1547l-.0084.0516h.4078c-.0247-.1463-.0848-.2063-.2014-.2063zm1.7274-.5753c.0777 0 .1413.0675.1413.15 0 .0824-.0636.1499-.1413.1499-.0776 0-.1411-.0675-.1411-.1499 0-.0825.0635-.15.141-.15z"
                              fill="#620010"
                              className=""
                            />
                            <path
                              d="M11.1521 11.5909c.483 0 .8762.2898.932.7753h-.4592a.4711.4711 0 00-.4711-.377c-.3864 0-.5855.305-.5855.7396 0 .4042.1898.722.5855.722.272 0 .45-.1754.4898-.4839h.4584c-.0483.544-.4195.8821-.9482.8821-.6584 0-1.0592-.4889-1.0592-1.1202h-.0017c0-.6372.3924-1.138 1.0592-1.138zm-1.171.0483v2.1556h-.4076v-.1991h-.006a.5126.5126 0 01-.4744.2465c-.444 0-.6789-.3574-.6993-.776l-.0015-.067c0-.4313.2415-.8093.6915-.8093a.5347.5347 0 01.4626.2373h.006v-.788h.4287zm6.5033 0v2.1556h-.4076v-.1991h-.0059a.5126.5126 0 01-.4745.2465c-.4652 0-.7007-.3923-.7007-.8363l.0008-.0068c0-.4312.2415-.8092.6914-.8092a.5347.5347 0 01.4618.233h.006v-.7837h.4287zm-8.947.555c.4923 0 .7626.3864.7626.8473v.078H7.1739c.0118.2686.1355.3957.3804.3957.1627 0 .3076-.0932.339-.2025h.3779c-.1153.3533-.3568.5253-.7313.5253-.4948 0-.7965-.339-.7965-.821-.0025-.4695.3228-.8228.794-.8228zm5.417-.006c.4559 0 .6779.1543.6779.444v.7516c0 .0912.014.118.0808.1229l.0395.0008v.278a.3754.3754 0 01-.178.0364c-.199 0-.3016-.0601-.3389-.2025-.1025.1237-.2838.2144-.544.2144-.3194 0-.5313-.1695-.5313-.4678h.0051a.411.411 0 01.1356-.3321c.09-.0763.2164-.1203.4328-.148l.1925-.0228c.1946-.0265.2814-.0616.2814-.1792 0-.1788-.1297-.2084-.2746-.2084-.1788 0-.272.072-.2872.2356h-.4288c.0187-.339.2991-.5229.7372-.5229zm1.8353.006a.3211.3211 0 01.094.0152v.3983a.7889.7889 0 00-.1541-.0144c-.311 0-.4237.2143-.4237.5007v.7033h-.4288l-.0025-1.5608h.4076v.2898h.0093a.549.549 0 01.4982-.3321zm-8.747-.555c.3804 0 .6312.2626.6312.5931 0 .272-.1144.45-.339.5406v.006c.2459.0688.2975.301.3133.4942l.007.1251c.0094.2026.0306.3195.0848.3949h-.4762a1.4134 1.4134 0 01-.061-.3737c-.0237-.3025-.072-.4686-.3711-.4686h-.477v.8423H4.881v-2.154h1.1617zm7.1617 1.3913c-.0341.0319-.0961.052-.2087.0686l-.0515.0068c-.2203.0271-.35.0754-.35.2449 0 .1237.0755.1991.2628.1991.2296 0 .3474-.1237.3474-.3533v-.1661zm-4.0088-.5126c-.2449 0-.3745.1957-.3745.4973 0 .2483.1144.5017.377.5017.2286 0 .3516-.1661.367-.4466l.0015-.0608c.0001-.2807-.1083-.4916-.371-.4916zm6.5042 0c-.245 0-.3745.1957-.3745.4973 0 .2483.1143.5017.377.5017.2286 0 .3516-.1661.367-.4466l.0016-.0576c0-.2839-.1084-.4948-.3711-.4948zm-8.1768 0a.3322.3322 0 00-.3491.3313h.693c-.0423-.2347-.1448-.3313-.344-.3313zm-1.649-.5076h-.5194v.6067h.522c.2 0 .3237-.0847.3237-.3076 0-.2228-.1178-.2991-.3263-.2991zm-2.592-.5728a1.2812 1.2812 0 011.282 1.282c0 .708-.574 1.282-1.282 1.282-.708 0-1.282-.574-1.282-1.282 0-.708.574-1.282 1.282-1.282zm0 .4262a.8558.8558 0 100 1.7116.8558.8558 0 000-1.7116zm0 .4169a.439.439 0 01.4398.439.4398.4398 0 11-.4926-.4358l.0528-.0032z"
                              fill="#FFF"
                              fillRule="nonzero"
                              className=""
                            />
                            <path
                              d="M.5625 1.9988C.5625 1.171 1.2335.5 2.0613.5h19.0024c.8278 0 1.4988.671 1.4988 1.4988v12.0024c0 .8278-.671 1.4988-1.4988 1.4988H2.0613c-.8278 0-1.4988-.671-1.4988-1.4988V1.9988zm.5 0v12.0024c0 .5122.3856.9344.8823.992L2.0613 15h19.0024c.5122 0 .9344-.3856.992-.8823l.0068-.1164V1.9988c0-.5122-.3856-.9344-.8823-.992L21.0637 1H2.0613c-.5122 0-.9344.3856-.992.8823l-.0068.1165z"
                              fill="#B30000"
                              fillRule="nonzero"
                              className=""
                            />
                          </g>
                        </svg>
                      </div>
                    </span>
                  </div>
                </div>
                <div
                  className="flex-row flex-none px-0 box-border"
                  style={{ outline: 0 }}
                >
                  <span className="" style={{ outline: 0, fontWeight: "bold" }}>
                    Save 5% every day
                  </span>
                  <br className="" />
                  <span
                    className="text-sm leading-5 text-stone-500"
                    style={{ outline: 0 }}
                  >
                    With RedCard
                  </span>
                </div>
                <div
                  className="flex flex-row flex-none justify-end px-0 box-border"
                  style={{ outline: 0 }}
                >
                  <a
                    href="/redcard/about?cpng=redcard9235"
                    className="flex overflow-visible relative items-center p-0 align-baseline bg-transparent border-0 cursor-pointer text-stone-500 focus:text-zinc-800 focus:outline-dashed focus:outline-1 hover:text-zinc-800"
                    aria-label="Learn more about RedCard"
                    data-test="redcard-link-financing"
                    style={{ textDecoration: "underline", boxShadow: "none" }}
                  >
                    <span
                      className="inline-block flex-shrink-0 w-8 h-8 font-sans text-base not-italic tracking-normal normal-case align-baseline whitespace-normal indent-0"
                      data-icon-name="NavigationArrowRightFill"
                      fill="#333333"
                      size={32}
                      style={{
                        outline: 0,
                        fill: "rgb(51, 51, 51)",
                        lineHeight: "1.4285",
                        fontWeight: "normal",
                        textShadow: "none",
                      }}
                    >
                      <div className="w-full h-full" style={{ outline: 0 }}>
                        <svg
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          focusable="false"
                          role="presentation"
                          className="block w-full h-full"
                          style={{ fill: "white", stroke: "none" }}
                        >
                          <path
                            d="M15.409 12l-7.47-7.47L9 3.47 17.53 12 9 20.53l-1.06-1.06z"
                            className=""
                          />
                        </svg>
                      </div>
                    </span>
                  </a>
                </div>
              </div>
              <div
                className="flex flex-initial items-center my-3 box-border"
                data-test="affirm-financing-block"
                style={{ outline: 0, flexFlow: "row wrap" }}
              >
                <div
                  className="flex-row flex-none px-0 box-border"
                  style={{ outline: 0 }}
                >
                  <div
                    className="flex justify-center items-center mt-1"
                    style={{ outline: 0 }}
                  >
                    <span
                      className="inline-block flex-shrink-0 w-6 h-6 font-sans text-base not-italic tracking-normal text-black normal-case align-baseline whitespace-normal indent-0"
                      data-icon-name="LogoAffirm"
                      fill="#000000"
                      style={{
                        outline: 0,
                        fill: "rgb(0, 0, 0)",
                        lineHeight: "1.4285",
                        fontWeight: "normal",
                        textShadow: "none",
                      }}
                    >
                      <div className="w-full h-full" style={{ outline: 0 }}>
                        <svg
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          focusable="false"
                          role="presentation"
                          className="block w-full h-full"
                          style={{ fill: "white", stroke: "none" }}
                        >
                          <path
                            d="M5.522 18.895a7.99 7.99 0 01-1.314-4.398c0-4.433 3.606-8.04 8.039-8.04s8.039 3.607 8.039 8.04a7.99 7.99 0 01-1.315 4.398h2.25a9.934 9.934 0 001.023-4.398c0-5.512-4.485-9.997-9.997-9.997S2.25 8.985 2.25 14.497c0 1.577.369 3.07 1.022 4.398h2.25z"
                            fill="#4A4AF4"
                            className=""
                          />
                          <path
                            d="M11.69 17.3c-.77 0-1.192-.329-1.192-.87 0-1.128 1.378-1.4 3.172-1.4 0 1.18-.79 2.27-1.98 2.27zm.693-7.553c-1.464 0-3.15.69-4.064 1.42l.835 1.757c.734-.67 1.92-1.244 2.99-1.244 1.016 0 1.577.34 1.577 1.024 0 .46-.373.72-1.075.785-2.637.242-4.687 1.066-4.687 3.09 0 1.605 1.157 2.576 3.061 2.576 1.274 0 2.276-.708 2.815-1.642v1.38h2.374v-5.786c0-2.389-1.66-3.36-3.826-3.36z"
                            fill="#060809"
                            className=""
                          />
                        </svg>
                      </div>
                    </span>
                  </div>
                </div>
                <div
                  className="flex-row flex-none px-0 box-border"
                  style={{ outline: 0 }}
                >
                  <span className="" style={{ outline: 0, fontWeight: "bold" }}>
                    Pay over time
                  </span>
                  <br className="" />
                  <span
                    className="text-sm leading-5 text-stone-500"
                    style={{ outline: 0 }}
                  >
                    With Affirm on orders over $100
                  </span>
                </div>
                <div
                  className="flex flex-row flex-none justify-end px-0 box-border"
                  style={{ outline: 0 }}
                >
                  <button
                    type="button"
                    aria-label="Learn more about Affirm"
                    className="inline-flex relative justify-center items-center p-0 m-0 h-auto font-sans text-sm not-italic tracking-normal text-center normal-case align-baseline bg-transparent rounded border border-transparent border-solid cursor-pointer select-none box-border truncate indent-0 text-stone-500 focus:outline-offset-2 hover:text-zinc-800"
                    data-test="affirm-info"
                    style={{
                      boxShadow: "none",
                      fontWeight: "normal",
                      textShadow: "none",
                      textDecoration: "underline",
                    }}
                  >
                    <span
                      className="inline-block flex-shrink-0 w-6 h-6 text-base not-italic text-black normal-case align-baseline whitespace-normal indent-0"
                      data-icon-name="AlertsInfoCircle"
                      fill="#000000"
                      size={24}
                      style={{
                        outline: 0,
                        fill: "rgb(0, 0, 0)",
                        lineHeight: "1.4285",
                        fontWeight: "normal",
                        textShadow: "none",
                      }}
                    >
                      <div className="w-full h-full" style={{ outline: 0 }}>
                        <svg
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          focusable="false"
                          role="presentation"
                          className="block w-full h-full"
                          style={{ fill: "white", stroke: "none" }}
                        >
                          <g fill="none" fillRule="evenodd" className="">
                            <path
                              d="M12 23.5C5.649 23.5.5 18.351.5 12S5.649.5 12 .5 23.5 5.649 23.5 12 18.351 23.5 12 23.5z"
                              className=""
                            />
                            <path
                              d="M12 .5C18.351.5 23.5 5.649 23.5 12S18.351 23.5 12 23.5.5 18.351.5 12 5.649.5 12 .5zM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm.75 7.75V18h-1.5V9.75h1.5zM12 6.5a1.12 1.12 0 110 2.24 1.12 1.12 0 010-2.24z"
                              fill="#666"
                              fillRule="nonzero"
                              className=""
                            />
                          </g>
                        </svg>
                      </div>
                    </span>
                  </button>
                </div>
              </div>
            </div>
            <div className="mb-8 text-zinc-800" style={{ outline: 0 }} />
          </div>
        </div>
      </div>
      {/* SECCION */}
      <div
        className="pt-4 my-4 leading-6 bg-neutral-100 text-zinc-800"
        data-test="product-detail-tabs-container"
        style={{ outline: 0 }}
      >
        <h2
          className="mx-0 mt-0 mb-2 font-sans text-2xl not-italic tracking-normal leading-tight text-center normal-case align-baseline whitespace-normal indent-0"
          data-test="tabListHeading"
          tabIndex={-1}
          style={{ outline: 0, textShadow: "none", fontWeight: "bold" }}
        >
          About this item
        </h2>
        <div
          className="ml-4 text-zinc-800"
          id="product-detail-tabs"
          style={{ outline: 0 }}
        >
          <div className="" style={{ outline: 0 }}>
            <div
              style={{ position: "relative", outline: 0 }}
              className="relative"
            >
              <div
                style={{
                  width: 50,
                  height: "100%",
                  position: "absolute",
                  top: 0,
                  zIndex: 1,
                  display: "block",
                  pointerEvents: "none",
                  opacity: 0,
                  transition: "opacity 300ms ease-out 0s",
                  outline: 0,
                }}
                className="block absolute top-0 w-12 h-full opacity-0 pointer-events-none"
              />
              <div
                className="relative w-full whitespace-nowrap border-b border-solid scroll-smooth border-zinc-500"
                style={{
                  whiteSpace: "nowrap",
                  overflow: "auto hidden",
                  outline: 0,
                }}
              >
                <ul
                  className="table px-px pt-1 pb-0 my-0 mx-auto font-sans text-base not-italic tracking-normal normal-case align-baseline whitespace-normal box-border indent-0"
                  style={{
                    listStyle: "outside none none",
                    marginBlock: 0,
                    marginInline: 0,
                    paddingInlineStart: 0,
                    lineHeight: "1.4285",
                    fontWeight: "normal",
                    textShadow: "none",
                    borderSpacing: 0,
                  }}
                >
                  <li
                    className="table-cell p-0 m-0 not-italic text-left normal-case align-baseline box-border indent-0"
                    style={{
                      listStyle: "outside none none",
                      marginBlock: 0,
                      marginInline: 0,
                      paddingInlineStart: 0,
                      lineHeight: "1.4285",
                      fontWeight: "normal",
                      textShadow: "none",
                      borderSpacing: "20px 0px",
                    }}
                  >
                    <a
                      href="#tabContent-tab-Details"
                      className="block overflow-visible relative py-2 px-3 m-0 text-center align-baseline bg-transparent border-t-0 border-b-2 border-red-700 border-solid cursor-pointer box-border border-x-0 focus:text-zinc-800 focus:outline-dashed focus:outline-1 focus:outline-offset-0 hover:text-zinc-800"
                      aria-label="Details - 1 of 3 - selected"
                      data-test="tabDetails"
                      id="tab-Details"
                      style={{
                        textDecoration: "none",
                        boxShadow: "none",
                        borderWidth: 0,
                        fontWeight: "bold",
                        transition: "border-color 200ms ease 0s",
                        borderSpacing: "20px 0px",
                        listStyle: "outside none none",
                      }}
                    >
                      <div
                        className="font-bold box-border"
                        style={{
                          outline: 0,
                          borderSpacing: "20px 0px",
                          listStyle: "outside none none",
                        }}
                      >
                        Details
                      </div>
                    </a>
                  </li>
                  <li
                    className="table-cell p-0 m-0 not-italic text-left normal-case align-baseline box-border indent-0"
                    style={{
                      listStyle: "outside none none",
                      marginBlock: 0,
                      marginInline: 0,
                      paddingInlineStart: 0,
                      lineHeight: "1.4285",
                      fontWeight: "normal",
                      textShadow: "none",
                      borderSpacing: "20px 0px",
                    }}
                  >
                    <a
                      href="#tabContent-tab-ShippingReturns"
                      className="block overflow-visible relative py-2 px-3 m-0 text-center align-baseline bg-transparent border-t-0 border-b-2 border-transparent border-solid cursor-pointer box-border border-x-0 text-stone-500 focus:text-zinc-800 focus:outline-dashed focus:outline-1 focus:outline-offset-0 hover:text-zinc-800"
                      aria-label="Shipping & Returns - 2 of 3"
                      data-test="tabShippingReturns"
                      id="tab-ShippingReturns"
                      style={{
                        textDecoration: "none",
                        boxShadow: "none",
                        borderWidth: 0,
                        transition: "border-color 200ms ease 0s",
                        borderSpacing: "20px 0px",
                        listStyle: "outside none none",
                      }}
                    >
                      <div
                        className="box-border"
                        style={{
                          outline: 0,
                          borderSpacing: "20px 0px",
                          listStyle: "outside none none",
                        }}
                      >
                        Shipping &amp; Returns
                      </div>
                    </a>
                  </li>
                  <li
                    className="table-cell p-0 m-0 not-italic text-left normal-case align-baseline box-border indent-0"
                    style={{
                      listStyle: "outside none none",
                      marginBlock: 0,
                      marginInline: 0,
                      paddingInlineStart: 0,
                      lineHeight: "1.4285",
                      fontWeight: "normal",
                      textShadow: "none",
                      borderSpacing: "20px 0px",
                    }}
                  >
                    <a
                      href="#tabContent-tab-QA"
                      className="block overflow-visible relative py-2 px-3 m-0 text-center align-baseline bg-transparent border-t-0 border-b-2 border-transparent border-solid cursor-pointer box-border border-x-0 text-stone-500 focus:text-zinc-800 focus:outline-dashed focus:outline-1 focus:outline-offset-0 hover:text-zinc-800"
                      aria-label="Q&A - 3 of 3"
                      data-test="tabQA"
                      id="tab-QA"
                      style={{
                        textDecoration: "none",
                        boxShadow: "none",
                        borderWidth: 0,
                        transition: "border-color 200ms ease 0s",
                        borderSpacing: "20px 0px",
                        listStyle: "outside none none",
                      }}
                    >
                      <div
                        className="box-border"
                        style={{
                          outline: 0,
                          borderSpacing: "20px 0px",
                          listStyle: "outside none none",
                        }}
                      >
                        Q&amp;A
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
              <div
                style={{
                  width: 50,
                  height: "100%",
                  position: "absolute",
                  top: 0,
                  zIndex: 1,
                  display: "block",
                  pointerEvents: "none",
                  opacity: 0,
                  transition: "opacity 300ms ease-out 0s",
                  outline: 0,
                }}
                className="block absolute top-0 w-12 h-full opacity-0 pointer-events-none"
              />
            </div>
            <div
              className=""
              data-test="tab-tabContent-tab-Details"
              id="tabContent-tab-Details"
              style={{ outline: 0 }}
            >
              <div
                data-test="productDetailTabs-itemDetailsTab"
                className="pr-4 pb-4 text-sm leading-5"
                style={{ outline: 0 }}
              >
                <div className="mb-3" style={{ outline: 0 }}>
                  <div
                    data-test="detailsTab"
                    className="overflow-hidden pb-4"
                    style={{ outline: 0, height: 300 }}
                  >
                    <span
                      className="inline-flex justify-evenly items-center mt-3 mb-1 w-full"
                      style={{ outline: 0 }}
                    />
                    <div
                      className="flex flex-initial my-4 box-border"
                      style={{ outline: 0, flexFlow: "row wrap" }}
                    />
                    <div
                      className="py-3 px-1 m-3 bg-white"
                      id="specAndDescript"
                      aria-hidden="true"
                      tabIndex={-1}
                      style={{ outline: 0 }}
                    >
                      <div
                        className="flex-row flex-none px-0 box-border lg:basis-1/2"
                        aria-hidden="true"
                        tabIndex={-1}
                        style={{ outline: 0 }}
                      >
                        <h3
                          className="mx-0 mt-0 mb-3 text-base font-bold"
                          style={{ outline: 0 }}
                        >
                          Description
                        </h3>
                        <div>
                          {`100% Polyester - Imported - Pull On closure - Hand
                          Wash Only - Red Bull Racing Team and Driver logos on
                          front & shoulders - Puma cat & Bull graphic on rear`}
                        </div>
                        <div
                          className="my-4"
                          data-test="item-details-description"
                          style={{ outline: 0 }}
                        >
                          <p className="m-0" style={{ outline: 0 }}>
                            <br className="" />
                            <br className="" />
                          </p>
                          <p className="m-0" style={{ outline: 0 }}>
                            <b className="" style={{ fontWeight: "bold" }}>
                              About the Book
                            </b>
                          </p>
                          <br className="" />
                          <br className="" />
                          "Includes new photos and bonus material"--Cover.
                          <p className="m-0" style={{ outline: 0 }}>
                            <br className="" />
                            <br className="" />
                          </p>
                          <p className="m-0" style={{ outline: 0 }}>
                            <b className="" style={{ fontWeight: "bold" }}>
                              {" "}
                              Book Synopsis{" "}
                            </b>
                          </p>
                          <br className="" />
                          <br className="" />
                          <b className="" style={{ fontWeight: "bold" }}>
                            Chris Perez tells the story of his relationship with
                            music superstar Selena in this heartfelt tribute.
                          </b>
                          <p className="m-0" style={{ outline: 0 }}>
                            One of the most compelling and adored superstars in
                            Latin music history, Selena was nothing short of a
                            phenomenon who shared all of herself with her
                            millions of devoted fans. Her tragic murder, at the
                            age of twenty-three, stripped the world of her
                            talent and boundless potential, her tightly-knit
                            family of their beloved angel, and her husband,
                            Chris Perez, of the greatest love he had ever known.
                          </p>
                          <p className="m-0" style={{ outline: 0 }}>
                            For over a decade, Chris held onto the only personal
                            thing he had left from his late wife--the touching
                            and sometimes painful memories of their very private
                            bond. Now, for the first time, Chris opens up about
                            their unbreakable friendship, their forbidden
                            relationship, and their blossoming marriage that was
                            cut short.
                          </p>
                          <p className="m-0" style={{ outline: 0 }}>
                            Chris's powerful story gives a rare glimpse into
                            Selena's sincerity and vulnerability when falling in
                            love, strength and conviction when fighting for that
                            love, and absolute resilience when finding peace and
                            normalcy with her family's acceptance of the only
                            man she called her husband.
                          </p>
                          <p className="m-0" style={{ outline: 0 }}>
                            While showcasing a side of Selena that has never
                            been disclosed before and clarifying certain
                            misconceptions about her life and death,
                            <i className="italic">To Selena, with Love</i> is an
                            everlasting love story that immortalizes the heart
                            and soul of an extraordinary, unforgettable, and
                            irreplaceable icon.
                          </p>
                          <p className="m-0" style={{ outline: 0 }}>
                            <b className="" style={{ fontWeight: "bold" }}>
                              This commemorative edition includes photos and a
                              special chapter detailing the author's reflection
                              since writing the book.
                            </b>
                          </p>
                          <p className="m-0" style={{ outline: 0 }}>
                            <br className="" />
                            <br className="" />
                          </p>
                          <p className="m-0" style={{ outline: 0 }}>
                            <b className="" style={{ fontWeight: "bold" }}>
                              About the Author
                            </b>
                          </p>
                          <br className="" />
                          <br className="" />
                          <b className="" style={{ fontWeight: "bold" }}>
                            Chris Perez
                          </b>
                          is a Grammy-winning American guitarist and currently
                          plays for The Chris Perez Band. Prior to that, Perez
                          was the lead guitarist for his wife's band Selena y
                          Los Dinos.
                        </div>
                      </div>
                      <div
                        className="flex flex-initial box-border"
                        aria-hidden="true"
                        tabIndex={-1}
                        style={{ outline: 0, flexFlow: "row wrap" }}
                      >
                        <div
                          className="flex-row flex-none px-0 box-border lg:basis-1/2"
                          data-test="item-details-specifications"
                          aria-hidden="true"
                          tabIndex={-1}
                          style={{ outline: 0 }}
                        >
                          <h3
                            className="mx-0 mt-0 mb-3 text-base font-bold"
                            aria-hidden="true"
                            tabIndex={-1}
                            style={{ outline: 0 }}
                          >
                            Specifications
                          </h3>
                          <div
                            aria-hidden="true"
                            tabIndex={-1}
                            className=""
                            style={{ outline: 0 }}
                          >
                            <div
                              aria-hidden="true"
                              tabIndex={-1}
                              className=""
                              style={{ outline: 0 }}
                            >
                              <b
                                aria-hidden="true"
                                tabIndex={-1}
                                className=""
                                style={{ fontWeight: "bold", outline: 0 }}
                              >
                                Suggested Age:
                              </b>
                              22 Years and Up
                            </div>
                            <hr
                              aria-hidden="true"
                              tabIndex={-1}
                              className="box-content my-3 h-0 border-b-0 border-t border-solid border-x-0 border-zinc-300"
                              style={{
                                borderWidth: "1px 0px 0px",
                                borderImage: "initial",
                                outline: 0,
                              }}
                            />
                          </div>
                          <div
                            aria-hidden="true"
                            tabIndex={-1}
                            className=""
                            style={{ outline: 0 }}
                          >
                            <div
                              aria-hidden="true"
                              tabIndex={-1}
                              className=""
                              style={{ outline: 0 }}
                            >
                              <b
                                aria-hidden="true"
                                tabIndex={-1}
                                className=""
                                style={{ fontWeight: "bold", outline: 0 }}
                              >
                                Number of Pages:
                              </b>
                              320
                            </div>
                            <hr
                              aria-hidden="true"
                              tabIndex={-1}
                              className="box-content my-3 h-0 border-b-0 border-t border-solid border-x-0 border-zinc-300"
                              style={{
                                borderWidth: "1px 0px 0px",
                                borderImage: "initial",
                                outline: 0,
                              }}
                            />
                          </div>
                          <div
                            aria-hidden="true"
                            tabIndex={-1}
                            className=""
                            style={{ outline: 0 }}
                          >
                            <div
                              aria-hidden="true"
                              tabIndex={-1}
                              className=""
                              style={{ outline: 0 }}
                            >
                              <b
                                aria-hidden="true"
                                tabIndex={-1}
                                className=""
                                style={{ fontWeight: "bold", outline: 0 }}
                              >
                                Format:
                              </b>
                              Paperback
                            </div>
                            <hr
                              aria-hidden="true"
                              tabIndex={-1}
                              className="box-content my-3 h-0 border-b-0 border-t border-solid border-x-0 border-zinc-300"
                              style={{
                                borderWidth: "1px 0px 0px",
                                borderImage: "initial",
                                outline: 0,
                              }}
                            />
                          </div>
                          <div
                            aria-hidden="true"
                            tabIndex={-1}
                            className=""
                            style={{ outline: 0 }}
                          >
                            <div
                              aria-hidden="true"
                              tabIndex={-1}
                              className=""
                              style={{ outline: 0 }}
                            >
                              <b
                                aria-hidden="true"
                                tabIndex={-1}
                                className=""
                                style={{ fontWeight: "bold", outline: 0 }}
                              >
                                Genre:
                              </b>
                              Biography + Autobiography
                            </div>
                            <hr
                              aria-hidden="true"
                              tabIndex={-1}
                              className="box-content my-3 h-0 border-b-0 border-t border-solid border-x-0 border-zinc-300"
                              style={{
                                borderWidth: "1px 0px 0px",
                                borderImage: "initial",
                                outline: 0,
                              }}
                            />
                          </div>
                          <div
                            aria-hidden="true"
                            tabIndex={-1}
                            className=""
                            style={{ outline: 0 }}
                          >
                            <div
                              aria-hidden="true"
                              tabIndex={-1}
                              className=""
                              style={{ outline: 0 }}
                            >
                              <b
                                aria-hidden="true"
                                tabIndex={-1}
                                className=""
                                style={{ fontWeight: "bold", outline: 0 }}
                              >
                                Sub-Genre:
                              </b>
                              Personal Memoirs
                            </div>
                            <hr
                              aria-hidden="true"
                              tabIndex={-1}
                              className="box-content my-3 h-0 border-b-0 border-t border-solid border-x-0 border-zinc-300"
                              style={{
                                borderWidth: "1px 0px 0px",
                                borderImage: "initial",
                                outline: 0,
                              }}
                            />
                          </div>
                          <div
                            aria-hidden="true"
                            tabIndex={-1}
                            className=""
                            style={{ outline: 0 }}
                          >
                            <div
                              aria-hidden="true"
                              tabIndex={-1}
                              className=""
                              style={{ outline: 0 }}
                            >
                              <b
                                aria-hidden="true"
                                tabIndex={-1}
                                className=""
                                style={{ fontWeight: "bold", outline: 0 }}
                              >
                                Publisher:
                              </b>
                              Celebra
                            </div>
                            <hr
                              aria-hidden="true"
                              tabIndex={-1}
                              className="box-content my-3 h-0 border-b-0 border-t border-solid border-x-0 border-zinc-300"
                              style={{
                                borderWidth: "1px 0px 0px",
                                borderImage: "initial",
                                outline: 0,
                              }}
                            />
                          </div>
                          <div
                            aria-hidden="true"
                            tabIndex={-1}
                            className=""
                            style={{ outline: 0 }}
                          >
                            <div
                              aria-hidden="true"
                              tabIndex={-1}
                              className=""
                              style={{ outline: 0 }}
                            >
                              <b
                                aria-hidden="true"
                                tabIndex={-1}
                                className=""
                                style={{ fontWeight: "bold", outline: 0 }}
                              >
                                Author:
                              </b>
                              Chris Perez
                            </div>
                            <hr
                              aria-hidden="true"
                              tabIndex={-1}
                              className="box-content my-3 h-0 border-b-0 border-t border-solid border-x-0 border-zinc-300"
                              style={{
                                borderWidth: "1px 0px 0px",
                                borderImage: "initial",
                                outline: 0,
                              }}
                            />
                          </div>
                          <div
                            aria-hidden="true"
                            tabIndex={-1}
                            className=""
                            style={{ outline: 0 }}
                          >
                            <div
                              aria-hidden="true"
                              tabIndex={-1}
                              className=""
                              style={{ outline: 0 }}
                            >
                              <b
                                aria-hidden="true"
                                tabIndex={-1}
                                className=""
                                style={{ fontWeight: "bold", outline: 0 }}
                              >
                                Language:
                              </b>
                              English
                            </div>
                            <hr
                              aria-hidden="true"
                              tabIndex={-1}
                              className="box-content my-3 h-0 border-b-0 border-t border-solid border-x-0 border-zinc-300"
                              style={{
                                borderWidth: "1px 0px 0px",
                                borderImage: "initial",
                                outline: 0,
                              }}
                            />
                          </div>
                          <div
                            aria-hidden="true"
                            tabIndex={-1}
                            className=""
                            style={{ outline: 0 }}
                          >
                            <b
                              aria-hidden="true"
                              tabIndex={-1}
                              className=""
                              style={{ fontWeight: "bold", outline: 0 }}
                            >
                              Street Date
                            </b>
                            : November 5, 2013
                            <hr
                              aria-hidden="true"
                              tabIndex={-1}
                              className="box-content my-3 h-0 border-b-0 border-t border-solid border-x-0 border-zinc-300"
                              style={{
                                borderWidth: "1px 0px 0px",
                                borderImage: "initial",
                                outline: 0,
                              }}
                            />
                          </div>
                          <div
                            aria-hidden="true"
                            tabIndex={-1}
                            className=""
                            style={{ outline: 0 }}
                          >
                            <b
                              aria-hidden="true"
                              tabIndex={-1}
                              className=""
                              style={{ fontWeight: "bold", outline: 0 }}
                            >
                              TCIN
                            </b>
                            : 77262583
                            <hr
                              aria-hidden="true"
                              tabIndex={-1}
                              className="box-content my-3 h-0 border-b-0 border-t border-solid border-x-0 border-zinc-300"
                              style={{
                                borderWidth: "1px 0px 0px",
                                borderImage: "initial",
                                outline: 0,
                              }}
                            />
                          </div>
                          <div className="" style={{ outline: 0 }}>
                            <b className="" style={{ fontWeight: "bold" }}>
                              UPC
                            </b>
                            : 9780451414069
                            <hr
                              className="box-content my-3 h-0 border-b-0 border-t border-solid border-x-0 border-zinc-300"
                              style={{
                                borderWidth: "1px 0px 0px",
                                borderImage: "initial",
                              }}
                            />
                          </div>
                          <div
                            aria-hidden="true"
                            tabIndex={-1}
                            className=""
                            style={{ outline: 0 }}
                          >
                            <b
                              aria-hidden="true"
                              tabIndex={-1}
                              className=""
                              style={{ fontWeight: "bold", outline: 0 }}
                            >
                              Item Number (DPCI)
                            </b>
                            : 247-53-1026
                            <hr
                              aria-hidden="true"
                              tabIndex={-1}
                              className="box-content my-3 h-0 border-b-0 border-t border-solid border-x-0 border-zinc-300"
                              style={{
                                borderWidth: "1px 0px 0px",
                                borderImage: "initial",
                                outline: 0,
                              }}
                            />
                          </div>
                          <div className="" style={{ outline: 0 }}>
                            <b className="" style={{ fontWeight: "bold" }}>
                              Origin
                            </b>
                            : Made in the USA or Imported
                            <hr
                              className="box-content my-3 h-0 border-b-0 border-t border-solid border-x-0 border-zinc-300"
                              style={{
                                borderWidth: "1px 0px 0px",
                                borderImage: "initial",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className="flex flex-initial m-3 box-border"
                        aria-hidden="true"
                        tabIndex={-1}
                        style={{ outline: 0, flexFlow: "row wrap" }}
                      >
                        <div
                          aria-hidden="true"
                          tabIndex={-1}
                          className=""
                          style={{ outline: 0 }}
                        >
                          If the item details above aren’t accurate or complete,
                          we want to know about it.
                          <button
                            data-test="link"
                            className="overflow-visible relative p-0 m-0 text-center normal-case align-baseline bg-transparent border-0 cursor-pointer text-stone-500 focus:text-zinc-800 hover:text-zinc-800"
                            type="button"
                            aria-hidden="true"
                            tabIndex={-1}
                            style={{
                              boxShadow: "none",
                              outline: 0,
                              textDecoration: "underline",
                            }}
                          >
                            Report incorrect product info.
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    data-test="fadeOut"
                    className="mx-4 -mt-4 w-full h-5 opacity-90 outline-0"
                    style={{
                      marginLeft: 16,
                      marginRight: 16,
                      width: "unset",
                      outline: 0,
                      content: '" "',
                      backgroundImage:
                        "linear-gradient(rgba(255, 255, 255, 0.2) 0%, rgb(255, 255, 255) 100%)",
                      zIndex: 1,
                    }}
                  />
                </div>
                <button
                  type="button"
                  data-test="toggleContentButton"
                  className="inline-flex relative justify-center items-center py-0 px-2 m-0 h-8 font-sans text-xs not-italic tracking-normal leading-none text-center normal-case align-middle bg-white rounded border border-solid cursor-pointer select-none box-border truncate border-zinc-500 indent-0 focus:outline-offset-2 hover:border-zinc-800 hover:bg-neutral-100 hover:text-zinc-800"
                  style={{
                    boxShadow: "none",
                    fontWeight: "normal",
                    textShadow: "none",
                    textDecoration: "none",
                  }}
                >
                  Show more
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TargetShop;
